if (!customElements.get('compare-table-selects')) {
  class CompareTableSelects extends HTMLElement {
    constructor() {
      super();

      this.selects = this.querySelectorAll('.compare_table__content-action-select');

      this.selects.forEach((select) => {
        select.addEventListener('change', () => this.changeSelect(select));
      });

      /* a11y: on mobile, sync column header visibility with initially active products */
      this.syncColumnHeaders();
    }

    changeSelect(select) {
      const section = select.closest('.compare-table');
      const oldContent = section.querySelectorAll(`[data-compare="${select.dataset.prevValue}"]`);
      const newContent= section.querySelectorAll(`[data-compare="${select.value}"]`);

      select.dataset.prevValue = select.value;

      oldContent.forEach((item) => {
        item.classList.remove('compare-active');

        if (select.classList.contains('compare_table__content-action-select--first') && item.classList.contains('compare-active--first')) {
          item.classList.remove('compare-active--first');
        }
      });

      newContent.forEach((item) => {
        if (select.classList.contains('compare_table__content-action-select--first')) {
          item.classList.add('compare-active', 'compare-active--first');
        } else {
          item.classList.add('compare-active');
        }
      });

      this.changeAvaialbleOptions();
      this.syncColumnHeaders();
      this.announceChange(section);

      /* a11y: VoiceOver loses its virtual cursor when display:none toggles
         rebuild the accessibility tree. Move focus to the select's wrapper
         first, then back to the select — this anchors VoiceOver's position. */
      select.blur();
      const wrapper = select.closest('.compare-table__content-action');
      if (wrapper) {
        if (!wrapper.hasAttribute('tabindex')) {
          wrapper.setAttribute('tabindex', '-1');
        }
        wrapper.focus();
        setTimeout(() => {
          select.focus();
        }, 100);
      }
    }

    changeAvaialbleOptions() {
      const selectedData = [];

      this.selects.forEach((select) => {
        selectedData.push(select.value);
      });

      this.selects.forEach(() => {
        const options = this.querySelectorAll(`option`);

        options.forEach((option) => {
          option.setAttribute('disabled', 'disabled');
        });

        options.forEach((option) => {
          if (!selectedData.includes(option.value)) {
            option.removeAttribute('disabled');
          }
        });
      });
    };

    /**
     * a11y: On mobile, only 2 products are visible. Column headers for hidden products
     * must be aria-hidden so VoiceOver doesn't announce phantom columns.
     * On desktop (selects not visible), all column headers remain exposed.
     */
    syncColumnHeaders() {
      const section = this.closest('.compare-table');
      if (!section) return;

      /* Only apply aria-hidden when mobile selects are visible */
      const isMobile = window.getComputedStyle(this).display !== 'none';

      const columnHeaders = section.querySelectorAll('[data-compare-header]');

      if (!isMobile) {
        /* Desktop: ensure all column headers are visible to AT */
        columnHeaders.forEach((header) => header.removeAttribute('aria-hidden'));
        return;
      }

      const selectedIds = [];
      this.selects.forEach((select) => selectedIds.push(select.value));

      columnHeaders.forEach((header) => {
        const blockId = header.getAttribute('data-compare-header');
        if (selectedIds.includes(blockId)) {
          header.removeAttribute('aria-hidden');
        } else {
          header.setAttribute('aria-hidden', 'true');
        }
      });
    }

    /* a11y: notify screen readers that the comparison has updated */
    announceChange(section) {
      let liveRegion = section.querySelector('.compare-table__live-region');
      if (!liveRegion) {
        liveRegion = document.createElement('div');
        liveRegion.className = 'compare-table__live-region visually-hidden';
        liveRegion.setAttribute('aria-live', 'polite');
        liveRegion.setAttribute('aria-atomic', 'true');
        section.appendChild(liveRegion);
      }

      const names = [];
      this.selects.forEach((select) => {
        const selected = select.options[select.selectedIndex];
        if (selected) names.push(selected.textContent.trim());
      });

      liveRegion.textContent = '';
      requestAnimationFrame(() => {
        liveRegion.textContent = names.length
          ? `Comparing ${names.join(' and ')}`
          : '';
      });
    }
  }

  customElements.define('compare-table-selects', CompareTableSelects);
}
